// docs/189 EO: the everyday objects' own art — one atlas packed by `tools/object-art.py` from
// assets/source/commissioned/objects/. Its `meta.things` names each kind's footprint, view and variants
// (`<Kind>_<NN>`, a lamp's unlit `_dark` and its flicker `_b`). A kind the atlas lacks, or `?oryx=1`, keeps the
// Oryx stand-in of `things.ts`.
import type Phaser from 'phaser';
import { variantOf } from '../../core/matter/shapes';

export const OBJECT_ATLAS = { key: 'objects', png: '/assets/objects/objects.png', json: '/assets/objects/objects.json' } as const;

export interface ObjectVariant { frame: string; dark?: string; b?: string }
export interface ObjectEntry { fp: [number, number]; view: 'stand' | 'low' | 'flat' | 'wall'; variants: ObjectVariant[] }
export type ObjectTable = Record<string, ObjectEntry>;

/** `?oryx=1`: the board keeps its Oryx look, things too. */
function oryx(): boolean {
  try { return new URLSearchParams(window.location.search).get('oryx') === '1'; } catch { return false; }
}

/** The atlas's table of things, once it has loaded (the texture's `customData.meta.things`). */
export function objectTable(scene: Phaser.Scene): ObjectTable | undefined {
  if (oryx() || !scene.textures.exists(OBJECT_ATLAS.key)) return undefined;
  const t = scene.textures.get(OBJECT_ATLAS.key) as unknown as { customData?: { meta?: { things?: ObjectTable } } };
  return t.customData?.meta?.things;
}

/** The variant thing `id` of `kind` is drawn in: the same on every client. */
export function objectVariant(table: ObjectTable | undefined, kind: string, id: number): ObjectVariant | undefined {
  const e = table?.[kind];
  if (!e?.variants.length) return undefined;
  return e.variants[variantOf(id, e.variants.length)];
}
